import React from "react";
import ContractPatternForm from "./ContractPatternForm";

export default function NewContractPattern() {
  return <ContractPatternForm />;
}
